import React, { useRef, useState, useEffect } from 'react';
import styled from 'astroturf/react';

import { Icon } from 'js/design_system/Icon';
import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';
import useOnClickOutside from 'js/utils/hooks/useOnClickOutside';
import AccountMenu from 'js/header/FocusedNav/AccountMenu';
import DoubleDigitCountBubble from 'js/header/FocusedNav/DoubleDigitCountBubble';
import { AccountMenuProps } from 'js/header/FocusedNav/AccountMenu';

const PositionedDoubleDigitCountBubble = styled(DoubleDigitCountBubble)`
  position: absolute;
  top: 2px;
  left: 30px;
`;

const UserButton = styled.button<{ small?: boolean }>`
  position: relative;
  height: 48px;
  padding: 4px 16px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  background: #e4ebf7;
  border: 1px solid #cedbf1;
  color: #0645b1;
  cursor: pointer;
  flex-grow: 0;
  max-width: 200px;

  &:hover,
  &:active,
  &:visited {
    color: #0645b1;
  }
  &:hover,
  &:focus {
    background: #0057eb;
    color: white;
  }

  display: flex;
  align-items: center;
`;

const ButtonProfilePic = styled.img`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 10px;
`;

const Caret = styled.div`
  margin-left: 6px;
  display: flex;
`;

const MenuContainer = styled.div`
  position: absolute;
  right: 0;
  top: 56px;
  width: 240px;
  box-shadow: 0px 20px 40px 0px #00000033;
  border-radius: 4px;
  background: white;
  padding: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #111111;
  text-align: initial;

  > * {
    margin: 8px;
  }
`;

const UserName = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

type AccountMenuButtonProps = AccountMenuProps & {
  totalCount: number;
  open: boolean;
  setOpen: (openness: boolean) => void;
};

const AccountMenuButton = ({
  totalCount,
  open,
  setOpen,
  ...accountMenuProps
}: AccountMenuButtonProps) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  const buttonRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  useOnClickOutside([buttonRef, menuRef], () => setOpen(false));

  return (
    <>
      <UserButton
        ref={buttonRef}
        onClick={() => setOpen(!open)}
        aria-pressed={open}
      >
        {isClient && currentUser != null && (
          <ButtonProfilePic src={$image_url(currentUser.photo)} />
        )}
        <PositionedDoubleDigitCountBubble count={totalCount} />
        <UserName>{isClient && currentUser?.first_name}</UserName>
        <Caret>
          <Icon name="keyboard_arrow_down" />
        </Caret>
      </UserButton>
      {open && (
        <MenuContainer ref={menuRef}>
          <AccountMenu {...accountMenuProps} />
        </MenuContainer>
      )}
    </>
  );
};

export default AccountMenuButton;
